import API from "../API";

var QuestionnaireBasic = {
    async LoadQuestionnaire(questionnaireId) {
        var result = await API.process(
            `api/QuestionnaireBasic/LoadQuestionnaire?questionnaireId=${questionnaireId}`,
            'GET',
            null
        ).catch((err) => {
            throw err;
        })

        return result
    }, async UpdateComponentLayout(questionnaireId, sectionId, componentId, layoutUpdate) {
        var result = await API.process(
            `api/QuestionnaireBasic/questionnaire/${questionnaireId}/section/${sectionId}/component/${componentId}/layout`,
            'PUT',
            layoutUpdate
        ).catch((err) => {
            throw err;
        })

        return result
    }, async SetComponentProperty(questionnaireId, sectionId, componentId, property, values, serialize) {
        console.log('handleUpdateComponentProperty', property, {
            property: property,
            values: values
        })
        var result = await API.process(
            `api/QuestionnaireBasic/questionnaire/${questionnaireId}/section/${sectionId}/component/${componentId}/property?${serialize === false ? `serialize=false` : ''}`,
            'PATCH',
            {
                property: property,
                values: String(values)
            }
        ).catch((err) => {
            throw err;
        })
    }
}

export default QuestionnaireBasic;